<template>
    <span>
    <v-alert
            type="error"
            v-if="extendConvertVisaDetail.late_days >0"
            outlined
    >
        You have {{$store.state["VisaType/borderCaseReachedDay"] >  0 && extendConvertVisaDetail.late_days > $store.state["VisaType/borderCaseReachedDay"] ?extendConvertVisaDetail.late_days - $store.state["VisaType/borderCaseReachedDay"] : extendConvertVisaDetail.late_days}} days late stay
        <span v-if="extendConvertVisaDetail.overstayed > 0">
            and {{extendConvertVisaDetail.overstayed}} days overstay
        </span>
        in current visa .
        <span v-if="overstay != 1">
            You will be charged <strong> USD ($) {{overstay == 1 ? extendConvertVisaDetail.late_days * 5 : late_cost}}  extra . </strong>
        </span>
        You need to apply for minimum {{total_days}} days
    </v-alert>

            </span>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "LateInfoMessage",
        props: ['cost', 'convert', 'overstay'],
        computed: {
            ...mapGetters('VisaType', ['conditions', 'extend_condition', 'visa_type_slug', 'old_visa', 'late_cost']),
            extendConvertVisaDetail() {
                return this.$store.state.VisaSingle.extendConvertVisaDetail;
            },
            late_fee_per_day() {
                let late_fee_per_day = this.extendConvertVisaDetail.late_fee_per_day;
                if (this.convert) {
                    const visa_type = this.$store.state.VisaSingle.convert_visa_options.find(i => i.id === this.extendConvertData.visa_type);
                    return visa_type.late_fee_per_day;
                }
                return late_fee_per_day;
            },
            extendConvertData() {
                return this.$store.state.VisaSingle.extendConvertData;
            },
            total_cost() {
                let late_cost = this.extendConvertVisaDetail.late_days * this.extendConvertVisaDetail.late_fee_per_day;

                if (this.extendConvertVisaDetail.overstayed > 0) {
                    let overstay_cost = this.extendConvertVisaDetail.overstayed * this.extendConvertVisaDetail.over_stay_cost_per_day;
                    late_cost = late_cost + overstay_cost;
                }
                return late_cost
            },
            total_days() {
                let total_days = this.extendConvertVisaDetail.late_days;
                if (this.extendConvertVisaDetail.overstayed > 0) {
                    total_days = total_days + this.extendConvertVisaDetail.overstayed;
                }
                return total_days;
            }
        }
    }
</script>
